<template>
  <TheApplicationsListFilters>
    <template #bottomLeftFilters>
      <TheApplicationNameOrDomain
        :is-fetching-district-apps="isFetchingDistrictApps"
        @update:app-name-or-domain-name="appNameOrDomainName = $event"
      />
    </template>
  </TheApplicationsListFilters>
</template>

<script setup lang="ts">
import { shallowRef, watch } from "vue";

import TheApplicationNameOrDomain from "../common/filters/TheApplicationNameOrDomain.vue";
import TheApplicationsListFilters from "../common/TheApplicationsListFilters.vue";

import type {
    UpdateApplicationsListPublicTableFiltersEvent,
} from "@/components/district-applications-list/types";

const { isFetchingDistrictApps } = defineProps<{ isFetchingDistrictApps: boolean; }>();

const emits = defineEmits<(e: "update:tableFilters", value: UpdateApplicationsListPublicTableFiltersEvent) => void>();

const appNameOrDomainName = shallowRef<string | undefined>();

watch([appNameOrDomainName], () => {
    emits("update:tableFilters", {
        appOrDomainName: appNameOrDomainName.value,
    });
});
</script>